import { faBriefcase, faBuildingFlag, faBuildingShield, faCar, faClipboardList, faCube, faFlagCheckered, faFolderOpen, faHandsBound, faHomeLg, faListAlt, faPause, faPeopleGroup, faShield, faTag, faUser, faUserGear, faUsers, faPersonWalkingArrowRight, faHandcuffs, faForwardFast } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import collapsedLogo from '../../../assets/icon_dispatch.png';
import logo from '../../../assets/logo_dispatch.png';
import { translate } from '../../services/translate';
import LateralMenu from '../LateralMenu';

export default function DispatchLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [];

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_occurrences
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_occurrences
        || authenticatedUser?.permissions.reopen_occurrence
        || authenticatedUser?.permissions.transfer_occurrence
        || authenticatedUser?.permissions.dispatch_manage_occurrences_bulk_finish
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_occurrences_bulk_finish
    ) {
        items.push({
            icon: faClipboardList,
            text: translate('occurrences'),
            action: () => navigation.navigate('Dispatch', { screen: 'Occurrences' }),
            selected: selectedMenu == 'occurrences'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_occurrence_tags
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_occurrence_tags
    ) {
        items.push({
            icon: faTag,
            text: translate('occurrenceTags'),
            action: () => navigation.navigate('Dispatch', { screen: 'OccurrenceTags' }),
            selected: selectedMenu == 'occurrence-tags'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_occurrence_types
    ) {
        items.push({
            icon: faListAlt,
            text: translate('occurrence_types'),
            action: () => navigation.navigate('Dispatch', { screen: 'OccurrenceTypes' }),
            selected: selectedMenu == 'occurrence-types'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_equipments
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_equipments
    ) {
        items.push({
            icon: faBriefcase,
            text: translate('equipments'),
            action: () => navigation.navigate('Dispatch', { screen: 'Equipments' }),
            selected: selectedMenu == 'equipments'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_download_report
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_download_report
        || authenticatedUser?.permissions.dispatch_generate_report
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_reports
    ) {
        items.push({
            icon: faFolderOpen,
            text: translate('reports'),
            action: () => navigation.navigate('Dispatch', { screen: 'DispatchReports' }),
            selected: selectedMenu == 'reports'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_report_tags
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_report_tags
    ) {
        items.push({
            icon: faTag,
            text: translate('reportTags'),
            action: () => navigation.navigate('Dispatch', { screen: 'ReportTags' }),
            selected: selectedMenu == 'report-tags'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_assignments
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_assignments
    ) {
        items.push({
            icon: faUserGear,
            text: translate('assignments'),
            action: () => navigation.navigate('Dispatch', { screen: 'Assignments' }),
            selected: selectedMenu == 'assignments'
        });
    }

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_vehicle_relations
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_vehicle_relations
    ) {
        items.push({
            icon: faCar,
            text: translate('vehicleRelations'),
            action: () => navigation.navigate('Dispatch', { screen: 'VehicleRelations' }),
            selected: selectedMenu == 'vehicle-relations'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_person_relations
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_person_relations
    ) {
        items.push({
            icon: faUser,
            text: translate('personRelations'),
            action: () => navigation.navigate('Dispatch', { screen: 'PersonRelations' }),
            selected: selectedMenu == 'person-relations'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_objects_categories
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_objects_categories
    ) {
        items.push({
            icon: faCube,
            text: translate('objectsCategories'),
            action: () => navigation.navigate('Dispatch', { screen: 'ObjectsCategories' }),
            selected: selectedMenu == 'objects-categories'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_team_names
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_names
        || authenticatedUser?.permissions.dispatch_manage_acting_body_units_unit_names
    ) {
        items.push({
            icon: faUsers,
            text: translate('teamNames'),
            action: () => navigation.navigate('Dispatch', { screen: 'TeamNames' }),
            selected: selectedMenu == 'team-names'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_unit_programs
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_programs
    ) {
        items.push({
            icon: faPeopleGroup,
            text: translate('teamPrograms'),
            action: () => navigation.navigate('Dispatch', { screen: 'TeamPrograms' }),
            selected: selectedMenu == 'team-programs'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_units
        || authenticatedUser?.permissions.dispatch_manage_acting_body_units
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_units
        || authenticatedUser?.permissions.dispatch_pause_units
    ) {
        items.push({
            icon: faShield,
            text: translate('teams'),
            action: () => navigation.navigate('Dispatch', { screen: 'Units' }),
            selected: selectedMenu == 'units'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_finish_categories
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_finish_categories
    ) {
        items.push({
            icon: faFlagCheckered,
            text: translate('finishCategories'),
            action: () => navigation.navigate('Dispatch', { screen: 'FinishCategories' }),
            selected: selectedMenu == 'finish-categories'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_see_resume
    ) {
        items.push({
            icon: faHomeLg,
            text: translate('general_vision'),
            action: () => navigation.navigate('Dispatch', { screen: 'Resume' }),
            selected: selectedMenu == 'resume'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_police_stations
    ) {
        items.push({
            icon: faBuildingShield,
            text: translate('policeStations'),
            action: () => navigation.navigate('Dispatch', { screen: 'PoliceStations' }),
            selected: selectedMenu == 'police-stations'
        });
    }
    if (
        authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_providences
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_providences
    ) {
        items.push({
            icon: faHandsBound,
            text: translate('providences'),
            action: () => navigation.navigate('Dispatch', { screen: 'Providences' }),
            selected: selectedMenu == 'providences'
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_unit_pause_reasons
        || authenticatedUser?.permissions.dispatch_manage_acting_body_units_unit_pause_reasons
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_pause_reasons
    ) {
        items.push({
            icon: faPause,
            text: translate('unitPauseReasons'),
            action: () => navigation.navigate('Dispatch', { screen: 'UnitPauseReasons' }),
            selected: selectedMenu == 'unit-pause-reasons'
        });
    }
    if (authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_unit_finish_early_reasons
        || authenticatedUser?.permissions.dispatch_manage_acting_body_units_unit_finish_early_reasons
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_finish_early_reasons
    ) {
        items.push({
            icon: faForwardFast,
            text: translate('unitFinishEarlyReasons'),
            action: () => navigation.navigate('Dispatch', { screen: 'UnitFinishEarlyReasons' }),
            selected: selectedMenu == 'unit-finish-early-reasons'
        });
    }
    if (
        authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_unit_displaced_reasons
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_displaced_reasons
    ) {
        items.push({
            icon: faPersonWalkingArrowRight,
            text: translate('unitDisplacedReasons'),
            action: () => navigation.navigate('Dispatch', { screen: 'UnitDisplacedReasons' }),
            selected: selectedMenu == 'unit-displaced-reasons',
        });
    }
    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_city_property
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_city_property
    ) {
        items.push({
            icon: faBuildingFlag,
            text: translate('cityProperties'),
            action: () => navigation.navigate('Dispatch', { screen: 'CityProperties' }),
            selected: selectedMenu == 'city-properties'
        });
    }

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dispatch_module_access
        || authenticatedUser?.permissions.dispatch_manage_handcuff_reasons
        || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_handcuff_reasons
    ) {
        items.push({
            icon: faHandcuffs,
            text: translate('handcuffReasons'),
            action: () => navigation.navigate('Dispatch', { screen: 'HandcuffReasons' }),
            selected: selectedMenu == 'handcuff-reasons'
        });
    }

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            items={items}
            authenticatedUser={authenticatedUser}
        />
    );
}
